module.exports = __webpack_public_path__ + "static/media/TN_Women_Sneakers_2.0.8c0908f5.svg";